import { useLazyQuery } from '@apollo/client';
import { IQueryResult, IVariables } from './interfaces';
import { qualityReturnReasonsListQuery } from './gql';

export const useReturnReasonsListGql = () => {
  const [runReturnReasonsList, { loading, data, error }] = useLazyQuery<IQueryResult, IVariables>(
    qualityReturnReasonsListQuery,
    {
      context: {
        headers: {
          userFunctionKey: 'a684eceee76fc522773286a895bc8436'
        }
      }
    }
  );

  return {
    runReturnReasonsList,
    loadingQualityReturnReasonsList: loading,
    dataQualityReturnReasonsList: data?.qualityReturnReasonsList || [],
    errorQualityReturnReasonsList: error
  };
};
